"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 *
 */
class Visitor {
  /**
   *
   */
  onSurfaceMount(surface) {}
  /**
   *
   */

  onSurfaceUnmount(surface) {}
  /**
   *
   */

  onSurfaceGLContextChange(surface, gl) {}
  /**
   */

  onSurfaceDrawSkipped(surface) {}
  /**
   */

  onSurfaceDrawStart(surface) {}
  /**
   * if returns true, it prevent a throw to happen from the request animation frame loop (or from a surface.flush() call).
   */

  onSurfaceDrawError(e) {
    return false;
  }
  /**
   */

  onSurfaceDrawEnd(surface) {}
  /**
   */

  onNodeDrawSkipped(node) {}
  /**
   */

  onNodeDrawStart(node) {}
  /**
   */

  onNodeSyncDeps(node, additions, deletions) {}
  /**
   */

  onNodeDraw(node, preparedUniforms) {}
  /**
   */

  onNodeDrawEnd(node) {}
}
exports.default = Visitor;